import styled from "styled-components";

export const StyledColorPicker = styled.input`
  width: 26px;
  height: 26px;
  background: none;
  border: none;
  outline: none;
`;
